import { ID } from '@phi/newtype';

export function keep_onshape_connection_alive(
    document: ID<'document'>,
    workspace: ID<'workspace'>,
    element: ID<'element'>,
) {
    window.parent.postMessage({
        documentId: document,
        workspaceId: workspace,
        elementId: element,
        messageName: 'keepAlive',
    }, '*');
}
